import {getSectors} from '../../api/sectors'
import getToken from '../account/getToken'

const hydrateSectors = store => async () => {
  let token

  try {
    token = await getToken(store)()
    if (!token) {
      store.setState({
        isHydratingSectors: false,
      })
      return
    }
  } catch (err) {
    return
  }

  store.setState({
    isHydratingSectors: true,
  })

  return getSectors({
    token,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(sectors => {
      store.setState({
        sectors,
        isHydratingSectors: false,
      })
    })
    .catch(error => {
      console.log(error)
      store.setState({
        isHydratingSectors: false,
      })
    })
}

export default hydrateSectors
